/** Left column of the loadout screen: the armory list with unit weight and RP price (04 §6). */

import type { PriceList } from '../../../meta/api';
import { box, el, panel } from '../dom';
import type { Describe } from '../text';
import { PACK_ITEMS, standardIssue } from './model';

/** `free`: Classic packs without RP (04 §1), so the price column reads FREE. */
export function armoryList(prices: PriceList, describe: Describe, free: boolean): HTMLElement {
  const p = panel('ARMORY', 'menu-load-armory');
  p.body.append(
    box(
      'menu-load-armory-row menu-load-armory-head',
      el('span', 'menu-load-armory-name', 'ITEM'),
      el('span', 'menu-load-armory-num', 'WT'),
      el('span', 'menu-load-armory-num', 'RP'),
    ),
  );
  const issue = standardIssue();
  for (const item of PACK_ITEMS) {
    const d = describe(item);
    const name = el('span', 'menu-load-armory-name menu-paper', d.name);
    const row = box(
      'menu-load-armory-row',
      name,
      el('span', 'menu-load-armory-num', String(prices.weight[item])),
      el('span', 'menu-load-armory-num', free ? 'FREE' : String(prices.price[item])),
    );
    row.title = d.text;
    const issued = issue[item] > 0 ? `STANDARD ISSUE: ${issue[item]}` : 'NOT ISSUED';
    p.body.append(row, el('div', 'menu-load-armory-issue menu-dim menu-small', issued));
  }
  p.body.append(
    el(
      'div',
      'menu-prose menu-dim menu-small menu-load-armory-foot',
      free
        ? 'CLASSIC: PACK FREELY WITHIN CAPACITY.'
        // What a pod IS was never said anywhere - only what it costs. Reported in play: "the
        // loadout for the drops isn't intuitive". The trade is the whole point of the screen, so
        // it is now stated: the ranger's kit is with him, a pod's kit is somewhere on the map.
        : 'WHAT IS ON THE RANGER LANDS WITH HIM. A POD FALLS SEPARATELY AND HAS TO BE WALKED TO -'
          + ' IT IS MARKED ON YOUR MAP ONCE IT IS DOWN. STANDARD ISSUE ON THE RANGER IS FREE;'
          + ' EVERYTHING IN A POD, AND ANYTHING BEYOND ISSUE, COSTS RP. AN EMPTY POD COSTS NOTHING.',
    ),
  );
  return p.panel;
}
